import React from 'react'

const FixedBar = ({   }) => {
    const [top, setTop] = React.useState(0);
    React.useEffect(() => {
        if(window.innerWidth > 900){
            window.addEventListener("scroll", (e) => {
                const d = document.getElementById("presentation").getBoundingClientRect();
                if(Math.abs(d.y) > 180) setTop(70)
                else setTop(0);
            })
        }
    }, [])
    return (
<div className="listing-nav" data-x-data="initListingNavbar()" 
    // data-x-init="initScrollAnchors()" 
    // data-x-on:scroll.window="scroll()" 
    // data-x-bind:class="{
    // 'is-active': scrolled,
    // '': !scrolled,
    // }"
    style={{ top }}
  >
  <div className="container">
    <div className="listing-nav-inner">
      <div className="left">
        <a href="#presentation" className="nav-item scroll-link">
          <span>Doctor</span>
        </a>
        <a href="#comments" className="nav-item scroll-link">
          <span>Comments</span>
        </a>
      </div>
      <div className="right">
        <a className="modal-trigger" data-modal="listing-share-modal">
          <i data-feather="share-2" />
          <span>Share</span>
        </a>
        <a className="modal-trigger" data-modal="listing-wishlist-modal">
          <i data-feather="heart" />
          <span>Save</span>
        </a>
        <a id="listing-navigation-action" data-x-show="scrolledFull === true" className="button is-primary is-raised-hover">
          Book this flat
        </a>
      </div>
    </div>
  </div>
</div>

    )
}

export default FixedBar
